import { Flex } from "@chakra-ui/react"
import React from "react"
import VNZAuthenticationFlow from "./authentication/VNZAuthenticationFlow"
import VNZLogoutButton from "./authentication/VNZLogoutButton"
import VNZImageBrowser from "./browser/VNZImageBrowser"
import { useVNZAuthenticationState } from "./hooks/useVNZAuthenticationState"

interface Props {
  isMobile: boolean
}

const CloudBrowserContentVNZ: React.FC<Props> = ({ isMobile }) => {
  const {
    state: { isAuthenticated },
  } = useVNZAuthenticationState()

  if (!isAuthenticated) {
    return <VNZAuthenticationFlow />
  }

  return (
    <Flex w="full" flex={1} flexDirection="column" overflow="hidden">
      <Flex
        borderWidth={0}
        justifyContent="flex-end"
        alignItems="center"
        px={4}
        py={4}
      >
        <VNZLogoutButton />
      </Flex>
      <VNZImageBrowser isMobile={isMobile} />
    </Flex>
  )
}

export default CloudBrowserContentVNZ
